<template>
	<div class="footer">
		<div class="webFooter">
			<div class="right">
				<div class="flex">
					<div class="item">
						<div class="title">关于我们</div>
						<div>企业介绍


						</div>
						<div>企业文化</div>
						<div>可持续发展</div>
						<div>服务保障</div>
					</div>
				</div>

			</div>
			<div class="left">
				<div class="contact">
					<!-- 	<div style="color: rgb(255, 255, 255);font-size: 16px;">
						联系我们</div>
					<div style="color: #c30d23;font-size: 18px;">CONTACT
						US
					</div> -->
				</div>
				<div style="line-height:  60px;font-size: 24px;color: #c30d23;margin-top: 30px;">中鑫奕博
				</div>

				<!-- <n-divider /> -->
				<div class="top_telb" style="line-height: 40px;font-size: 24px;color:#fff;">
					<div>
						<div style="font-size: 14px;color:#fff;line-height: 20px;font-weight: normal;">服务热线：</div>
						13653450838 0355-8516630

					</div>

				</div>
				<div class="f_add" style="font-size: 12pt;color:#fff;">地址：山西省长治市保宁西街309号世纪城第 1 幢商业 1208
				</div>
			</div>
			<!-- <n-divider vertical style="height: 100%;" /> -->


		</div>

		<div class="copyright">
			©2022 中鑫奕博 版权所有
		</div>


	</div>
</template>

<script>
	export default {

	}
</script>

<style lang="less">
	.f_add {
		background: url(../assets/new/add1.png) no-repeat left 0px;
		padding-left: 30px;
		margin-bottom: 6px;
		color: #fff;
	}

	.top_telb {
		margin-top: 10px;
		height: 77px;
		font-size: 24px;
		font-weight: bold;
		align-items: center;
		display: flex;
		padding-left: 45px;
		background: url(../assets/new/telb.png) no-repeat left center;
	}

	.webFooter {
		width: 98%;
		max-width: 1460px;
		min-width: 0px;
		height: auto;
		max-height: none;
		min-height: 192px;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 1%;
		padding-top: 0px;
		padding-left: 0px;
		padding-right: 0px;
		padding-bottom: 0px;
		display: flex;

		.left {
			text-align: left;
			margin-right: 60px;

			.contact {
				border-left: solid 3px #c30d23;
				padding-left: 16px;
			}
		}

		.right {
			margin-left: 60px;
			flex: 1;

			.item {
				padding: 20px 60px;
				color: #909096;
				line-height: 32px;

				.title {
					margin-bottom: 32px;
					color: #fff;
				}
			}
		}
	}


	.footer {
		position: relative;
		padding: 0;
		width: 100%;
		background: #353840;
	}

	.copyright {
		text-align: center;
		color: #D3D3D3;
		background-color: #c30d23;
		width: auto;
		max-width: none;
		min-width: 0px;
		height: 28px;
		max-height: none;
		min-height: 0px;
		margin-top: 0px;
		margin-left: 0px;
		margin-right: 0px;
		margin-bottom: 0px;
		padding-top: 20px;
		padding-left: 0px;
		padding-right: 0px;
		padding-bottom: 20px;

	}
</style>
